export default __webpack_public_path__ + "static/media/dashboard.a0d515d3.png";